import React from 'react';
import { RestaurantActions } from 'modules/restaurant/actions';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import closeWhite from 'assets/images/closewhite.png';
//eslint-disable-next-line
import styles from "./styles.scss";

export const RestaurantMobileMenuOverlay = props => {
  const { data, toggleModal } = props;
  return <div className={'restaurant-menu-modal'}>{data}</div>;
};

const mapDispatchToProps = dispatch => {
  const { toggleModal } = RestaurantActions;
  return bindActionCreators(
    {
      toggleModal,
    },
    dispatch
  );
};

const connectedComponent = connect(
  null,
  mapDispatchToProps
)(RestaurantMobileMenuOverlay);

export default connectedComponent;
